export enum AdjustmentMethodType {
  Manual = "Manual",
  Import = "Import",
}

export enum AdjustmentType {
  BeforeTax = "BEFORE_TAX",
  AfterTax = "AFTER_TAX",
}

export interface AdjustmentCreateRequest {
  data: AdjustmentCreateData[];
  year: number;
  month: number;
  templateId: string;
  templatePeriod: number;
  cycleId?: string;
  runWithAdjustment?: boolean;
}

interface AdjustmentCreateData {
  employeeCode: string;
  employeeFullName: string;
  employeeEmail: string;
  type: string;
  amount: number;
  description: string;
  groupTransaction?: string;
}

export interface Adjustment {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: unknown;
  status: number;
  createdBy: CreatedBy;
  updatedBy?: unknown;
  ownerList?: unknown;
  orgId: number;
  month: number;
  year: number;
  templateId: string;
  employeeId: number;
  employeeCode: string;
  employeeFullName: string;
  employeeEmail: string;
  type: string;
  amount: number;
  description: string;
  isUse: boolean;
}

interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

export interface AdjustmentListResponse extends RestAPIMetaResponse {
  items: Array<Adjustment>;
}
